import { render } from "./V_Header.vue?vue&type=template&id=1bd17a56"
import script from "./V_Header.vue?vue&type=script&lang=js"
export * from "./V_Header.vue?vue&type=script&lang=js"

import "./V_Header.vue?vue&type=style&index=0&id=1bd17a56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__